const initialState = {
  settingsList: [],
  locations: [],
  total_locations_count: 0,
  distributors: [],
  total_distributors_count: 0,
  users: [],
  total_users_count: 0,
  subcription_lists: [],
  org_setting_lists: [],
  tdForcastList: [],
  total_tdForcastList_count: 0,
  buForcastList: [],
  total_buForcastList_count: 0,
  params: null,
  allData: [],
  totalPages: 0,
  filteredData: [],
  totalRecords: 0,
  sortIndex: [],
  settingsUpdateResult :{},
  settingsViewResult :{}
}


const SettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ALL_DATA":
      return {
        ...state,
        settingsList: action.data.settingList,
      }

    case "ADD_DATA":
      return {
        ...state,
      }
      case "VIEW_DATA":
      return {
        ...state,
        settingsViewResult: action.data
      }
    case "UPDATE_DATA":
      return { ...state ,
        settingsUpdateResult: action.data}
    case "DELETE_DATA":
      return {
        ...state,
      }
    default:
      return state
  }
}

export default SettingsReducer
